import { AppBundle, OpPlusBundle, ShipmentBundle } from 'api/optimalprint-sdk.d';
import { Recommendation } from 'store/landing/slice';

export interface ProductState {
  designProduct?: AppBundle.Api.Response.Design.V2.DesignAbstractProductPageGetV2Response;
  personalisedProduct?: AppBundle.Api.Entity.App.V1.IProductPage;
  encPublicDesignId?: string;
  productType?: ProductType;
  productId: number;
  productName?: string;
  productUid?: string;
  isInitialProduct: boolean;
  productAttributes: {
    [typeName: string]: string[];
  };
  selectedBundleProducts: BundledProduct[];
  quantity: number;
  initialQuantity: number;
  deliveryDetails?: ShipmentBundle.Entity.API.ShipmentPrice.ShipmentPriceListV2Response;
  deliveryOptions?: ShipmentBundle.Entity.API.ShipmentPrice.ShipmentPriceListDetailedV2Response.IShipmentDetails;
  forcedProductPreviews: {
    [index: string]: string;
  };
  productPreviewIndex: number;
  defaultProductPreviews: string[];
  preventFromProceed: boolean;
  productRecommendations: {
    [key in ProductRecommendationSlot]?: ProductRecommendations;
  };
  addingToCartFlow: AddToCartFlow;
  lastOrderItemId?: number;
  lastEncOrderItemId?: string;
  matchingProducts: AppBundle.Api.Response.Category.V2.CategoryMatchingProductsListV2Response.MatchingProduct[];
  frameUpsellPopupData?: AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response;
  frameUpsellSelectedFrame?: number;
  OPPlustContent?: OpPlusBundle.Entity.API.Membership.Response.V1.OpPlusProductsV1Response;
  moreArtPrints?: any[];
  fetchedProductUid?: string;
  othersAlsoBoughtProducts?: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Family.IDesign[];
  everyItemOutOfStock?: boolean;
}

export interface ExtendedProduct {
  avalilabilityStatus?: {
    status: string;
    label: string;
  } | null;
}

export enum STOCK_STATUS {
  STATUS_NO_INFO = 'no_info',
  STATUS_NO_SUITABLE = 'no_suitable',
  STATUS_AVAILABLE = 'available',
  STATUS_UNAVAILABLE = 'unavailable',
}

export enum ProductType {
  predesigned = 'predesigned',
  personalized = 'personalized',
}

export interface ProductItemPreviewProps {
  productUrl?: string;
  productThumbnail?: string;
  productName?: string;
  categoryId?: number;
  productId?: number;
  showPrice: boolean;
  usePriceFromProps?: boolean;
  theme?: string;
  initialPrice?: number;
  initialPriceFormatted?: string;
  finalPrice?: number;
  finalPriceFormatted?: string;
  timestamp?: number;
  uniqueProductId?: string;
  useFixedContainerSize?: boolean;
  onClick?: () => void;
}

export interface BundledProduct {
  bundleGroupId: number;
  productId: number;
  categoryId: number;
}

export enum AddToCartFlow {
  'idle' = 'idle',
  'addingToCart' = 'addingToCart',
  'addedToCart' = 'addedToCart',
  'failedToAddToCart' = 'failedToAddToCart',
  'bundlingProduct' = 'bundlingProduct',
  'bundlingCompleted' = 'bundlingCompleted',
  'bundlingFailed' = 'bundlingFailed',
}

export enum ProductRecommendationSlot {
  POPULAR_IN_THE_SAME_CATEGORY = 'POPULAR_IN_THE_SAME_CATEGORY',
  OTHERS_ALSO_BOUGHT = 'OTHERS_ALSO_BOUGHT',
}

export interface ProductRecommendations {
  products: AppBundle.Api.Entity.Design.V1.ISimilarProduct[] | Recommendation[];
  slotName: string;
  rootCategoryId?: number;
}

export enum SupportMaterialTypes {
  supporting_materials_instruction_pdf_url = 'supporting_materials_instruction_pdf_url',
  supporting_materials_instruction_video_url = 'supporting_materials_instruction_video_url',
}

export interface SupportMaterial {
  type: SupportMaterialTypes;
  value: string;
}

export interface RecommendedProductPrice {
  currency: string;
  formatted: string;
  value: number;
}

export interface RecommendedProduct {
  abstractProductId: number;
  finalPrice: RecommendedProductPrice;
  imageUrl: string;
  initialPrice: RecommendedProductPrice;
  priceTranslationKey: string;
  referenceUrl: string;
  title: string;
}
